<template>
  <div>
    <common-header title="Gallery">
      <el-form :model="filters" inline>
        <el-form-item
          v-for="(value, key) in filters"
          :key="key"
          :label="_.upperFirst(key)"
        >
          <el-select
            v-model="filters[key]"
            multiple
            filterable
            clearable
            collapse-tags
            v-if="key !== 'name'"
          >
            <el-option
              v-for="(v, k) in filterOptions[key]"
              :key="k"
              :label="v"
              :value="Number(k)"
            ></el-option>
          </el-select>
          <el-input v-model="filters[key]" v-else></el-input>
        </el-form-item>
      </el-form>
    </common-header>

    <el-row :gutter="40" style="padding-bottom: 20px;">
      <el-col
        v-for="(col, colIndex) in filterTypeInfo"
        :key="colIndex"
        :lg="8"
        :sm="12"
        :xs="24"
        style="margin-bottom: 20px;"
      >
        <el-card
          shadow="hover"
          :body-style="{
            padding: '0px',
          }"
          style="border-radius: 20px; position: relative; cursor: pointer; padding: 20px;"
          @mouseover.native="visibleChange(col.type)"
          @mouseout.native="visibleChange('')"
          @click.native="
            showDialog({
              type: CONSTANT.DIALOG_TYPE.CREATIVE_DETAIL,
              row: { _type: col.type },
            })
          "
        >
          <el-row style="padding-bottom: 20px">
            <h6
              class="title"
              style="font-size: 20px; border-left: solid 7px; padding-left: 15px;"
            >
              {{ col.name }}
            </h6>
            <div v-if="!col.isSuitCreatorLevel">
              <img
                src="@/assets/upgrade.svg"
                style="width:36px; height:36px; position:absolute; top:-20px; right:0px"
              />
            </div>
          </el-row>
          <el-row type="flex" align="bottom">
            <el-col :span="11" :offset="4">
              <el-image :src="col.src" fit="contain"></el-image>
            </el-col>
            <el-col :span="4" :offset="5">
              <el-form size="mini">
                <span class="icon-container" v-for="asset in col.assets">
                  <el-tooltip
                    effect="dark"
                    :content="getTooltip('asset', asset)"
                    placement="right"
                  >
                    <i
                      class="fas"
                      :class="assetToIcon(asset)"
                      style="color: #EF767A"
                    >
                    </i>
                  </el-tooltip>
                </span>
                <span class="icon-container" v-for="device in col.devices">
                  <el-tooltip
                    effect="dark"
                    :content="getTooltip('device', device)"
                    placement="right"
                  >
                    <i
                      class="fas"
                      :class="deviceToIcon(device)"
                      style="color: #445d9e"
                    >
                    </i>
                  </el-tooltip>
                </span>
              </el-form>
            </el-col>
          </el-row>
        </el-card>
      </el-col>
    </el-row>
    <dialogs></dialogs>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import CommonHeader from "@/components/base/header";
import Dialogs from "@/components/common/dialogs/index";
export default {
  data() {
    return {
      isVisible: "",
      filters: {
        assets: [],
        devices: [],
        features: [],
        name: "",
      },
      colNum: 3,
    };
  },
  components: {
    CommonHeader,
    Dialogs,
  },
  computed: {
    ...mapState({
      typeInfo: (state) => state.creative.typeInfo,
      filterOptions: (state) => state.creative.filterOptions,
      advertisers: (state) => state.advertiser.advertisers,
      audiences: (state) => state.audience.audiences,
      assets: (state) => state.asset.assets,
      userInfo: (state) => state.user.userInfo,
    }),
    mixBasicVideoType() {
      return _.reduce(
        this.typeInfo,
        (mixBasicVideoType, creative) => {
          const VideoFormat = creative.type + "WithOutstream";
          const hasVideoFormat = _.find(
            this.typeInfo,
            (typeInfo) => typeInfo.type === VideoFormat
          );
          const isVideoFormat = _.includes(creative.type, "WithOutstream");

          if (hasVideoFormat) {
            mixBasicVideoType.push({
              ...creative,
              assets: _.union(creative.assets, hasVideoFormat.assets),
              devices: _.union(creative.devices, hasVideoFormat.devices),
              features: _.union(creative.features, hasVideoFormat.features),
            });
          } else if (!isVideoFormat) {
            mixBasicVideoType.push({
              ...creative,
            });
          }
          return mixBasicVideoType;
        },
        []
      );
    },
    filterTypeInfo() {
      return _.filter(this.mixBasicVideoType, (typeInfo) => {
        const { assets, devices, features, name } = this.filters;
        const assetIntersection = _.intersection(assets, typeInfo.assets);
        const deviceIntersection = _.intersection(devices, typeInfo.devices);
        const featureIntersection = _.intersection(features, typeInfo.features);
        return (
          (!assets.length || assets.length === assetIntersection.length) &&
          (!devices.length || devices.length === deviceIntersection.length) &&
          (!features.length ||
            features.length === featureIntersection.length) &&
          (!name || typeInfo.name.toLowerCase().includes(name.toLowerCase()))
        );
      });
    },
    typeInfoGroup() {
      return _.chunk(this.filterTypeInfo, this.colNum);
    },
  },
  async created() {
    let req_list = [];
    if (!this.advertisers.length) {
      req_list.push(store.dispatch("advertiser/getAdvertisers"));
    }
    if (!this.audiences.length) {
      req_list.push(store.dispatch("audience/getAudiences"));
    }
    if (!this.assets.length) {
      req_list.push(store.dispatch("asset/getAssets"));
    }
    await Promise.all(req_list);
  },
  methods: {
    ...mapActions({
      showDialog: "showDialog",
    }),
    visibleChange(type) {
      this.isVisible = type;
    },
    assetToIcon(assetIndex) {
      let assetType = this.filterOptions.assets[assetIndex];
      return {
        "fa-image": assetType === "Image",
        "fa-video": assetType === "Video",
      };
    },
    deviceToIcon(deviceIndex) {
      let deviceType = this.filterOptions.devices[deviceIndex];
      return {
        "fa-desktop": deviceType === "desktop",
        "fa-mobile-alt": deviceType === "mobile",
      };
    },
    getTooltip(type, index) {
      let assetDevice = "";
      if (type === "device") {
        assetDevice = this.filterOptions.devices[index];
      } else {
        assetDevice = this.filterOptions.assets[index];
      }
      let tooltipContent =
        "Support " + assetDevice.charAt(0).toUpperCase() + assetDevice.slice(1);
      return tooltipContent;
    },
  },
};
</script>

<style lang="sass" scoped>
button
  display: block
  position: absolute
  margin: auto
  top: 50%
  bottom: 0
  left: 0
  right: 0
  width: 70%
  height: 40px
  font-size: 24px

.icon-container
  display: block
  width: 35px
  height: 35px
  background-color: #E4E7ED
  font-size: 19px
  border-radius: 50%
  padding: 7px 0px
  margin-bottom: 11px
  i
    width: 100%
    height: 100%
    text-align: center
    padding: 0px
</style>
